import {RequestField} from "../classes/request_field";

export interface IConfigurationEvent {
  settings?: {
    show_gateways?: boolean;
    request_fields?: Record<string, object>;
    response_fields?: Record<string, object>;
  };
  gateways: Record<string, string>;
}

type NonFunctionPropertyNames<T> = {
  [K in keyof T]: K extends `_${string}` ? never : T[K] extends Function ? never : K;
}[keyof T];

type PropertiesOnly<T> = Pick<T, NonFunctionPropertyNames<T>>;

export type IRequestField = PropertiesOnly<RequestField>;

export interface IConfigurationUpdate {
  requestFields: Record<string, object>;
  responseFields: Record<string, object>;
}
